import React from 'react';
import '../../styles/components/AsperaAccordion.scss';
import { getIcon } from '../Carbon';
/**
 * React Component
 *
 * The AsperaAccordion renders the accordion items
 *
 * @example
 * ```javascript
 * <AsperaAccordion><AsperaAccordionItem title="Test">Inner content</AsperaAccordionItem></AsperaAccordion>
 * ```
 */
export class AsperaAccordion extends React.Component {
    render() {
        const { className, children, dataAuto } = this.props;
        return (React.createElement("div", { className: `aspera-accordion ${className ? className : ''}`, "data-auto": dataAuto }, children));
    }
}
export class AsperaAccordionItem extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.toggleOpen = () => {
            const { open } = this.state;
            this.setState({ open: !open });
        };
    }
    componentDidMount() {
        const { open } = this.props;
        if (open) {
            this.setState({ open });
        }
    }
    render() {
        const { className, children, dataAuto, title } = this.props;
        const { open } = this.state;
        return (React.createElement("div", { className: `aspera-accordion-item ${open ? 'aspera-accordion-item--open' : ''} ${className ? className : ''}`, "data-auto": dataAuto },
            React.createElement("button", { type: "button", onClick: this.toggleOpen, className: "aspera-accordion-item-header" },
                React.createElement("span", { className: "aspera-accordion-item-header--title" }, title),
                getIcon(open ? 'ChevronUp' : 'ChevronDown', 16, { className: 'aspera-accordion-item-header--icon' })),
            React.createElement("div", { className: `aspera-accordion-item-content ${open ? 'aspera-accordion-item-content--open' : ''}` }, children)));
    }
}
